import React from "react";
import { useNavigate } from 'react-router-dom'

import { getSS, countryNameFromCode } from '../../helpers'

const PaymentDetails: React.FC = () => {

  const navigate = useNavigate()
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const membership = getSS('membership')
  const details = getSS('details')
  const jointMembershipTypes = [
    'jointfriend',
    'jointfamfriend',
    'wakehurst_jointfriend',
    'wakehurst_jointfamfriend',
    'jointfriendplus',
    'jointfamfriendplus',
    'wakehurst_family_2adults',
    'wakehurst_family_2adultsplus',
    'wakehurst_jointadult',
    'wakehurst_jointadultplus'
  ]
  const jointMembership = jointMembershipTypes.includes(membership.selected_membership.value)

  return (
    <>
      <div className="row">
        <div className="payment-details clearfix box">
          <div className="large-12 columns">
            <p>Please check your details before proceeding.</p>
          </div>
          <div className="medium-6 columns">
            <div className="member-details">
              <div className="title">Your membership {membership_form.form_type === 'upgrade' && <span>upgrade</span>}</div>
              <div className="details">
                { membership_form.form_type !== 'upgrade' &&
                  <p>1 x {membership.selected_membership?.title} @ £{(membership.amount)?.toFixed(2)}</p>
                }
                { membership_form.form_type === 'upgrade' &&
                  <p>1 upgrade from {membership.selected_membership?.upgrade_from} to {membership.selected_membership?.title} @ £{(membership.amount)?.toFixed(2)}</p>
                }
              </div>
              <div className="title">Your contact details</div>
              <div className="details">
                <p>{details.salutation} {details.first_name} {details.last_name}<br />{details.email}<br />{details.phone}</p>
              </div>
              { jointMembership &&
                <>
                  <div className="title">Joint member details</div>
                  <div className="details">
                    <p>{details.second_named_adult_salutation} {details.second_named_adult_first_name} {details.second_named_adult_last_name}<br />{details.second_named_adult_email}<br />{details.second_named_adult_phone}</p>
                  </div>
                </>
              }
              <div className="title">Your address</div>
              <div className="details address">
                <p>
                  <span>{details.organisation}</span>
                  <span>{details.address_1}</span>
                  <span>{details.address_2}</span>
                  <span>{details.address_3}</span>
                  <span>{details.town_city}</span>
                  <span>{details.county_state}</span>
                  <span>{details.postcode}</span>
                  <span>{countryNameFromCode(details.country)}</span>
                </p>
              </div>
            </div>
            <div className="actions">
              { membership_form.form_type === 'upgrade' &&
                <p>This will upgrade your current membership until the next expiry date, printed on your card. If you have a direct debit instruction with Kew, the membership will renew in the upgraded option. We will send you the usual advance reminder letter with enough notice.</p>
              }
              <p>Want to change something? Select BACK to go back and edit your details.</p>
              <button type="button" className="btn-cta back" id="m-change-details" onClick={() => navigate(-1)}>Back</button>
            </div>
          </div>
          <div className="medium-6 columns membership-image">
            <img src={membership.selected_membership?.image} alt={membership.selected_membership?.alt} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PaymentDetails;